export class DealApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getDataByApplicationId({ applicationId }, config) {
    return this.#http.get(`/deal/by-application/${applicationId}`, config);
  }

  async getDataByLoanId({ loanId }) {
    return this.#http.get(`/deal/by-loan/${loanId}`);
  }
}
